// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { setChartId } from './chart-id.action';
import { setScatterPlot } from '../scatter-plot.actions';
export const chartId = createReducer(null, on(setChartId, (state, action) => {
    return action.chartId;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.chartId;
}));
